import classNames from 'classnames'
import { EmptyFunction } from '../utils/functions'

export const RadioButton = ({
  onClick = EmptyFunction,
  outerClassName,
  innerClassName,
  isClicked = false,
  isCPMFlow = false
}) => (
  <div
    id="radio_button"
    className={classNames(
      'flex items-center justify-center rounded-full border-[2px] border-solid border-lightGray text-center',
      outerClassName,
      isClicked && 'border-[#323232] bg-white',
      !isCPMFlow && ' h-[20px] w-[20px]',
      isCPMFlow && ' h-[24px] w-[24px]'
    )}
    {...{ onClick }}
  >
    {isClicked && (
      <div
        className={classNames(
          'flex h-[10px] w-[10px] animate-w_increase self-center rounded-full bg-[#323232]',
          innerClassName
        )}
      ></div>
    )}
  </div>
)
